import {MobileSize} from "@/components/responsive";
import {useEffect, useState} from "react";
import {twMerge} from "tailwind-merge";

export default function MobileSimpleModal({onCloseModal, open, children, classes = {}}) {

    const {parentClasses = "", overlayClasses = "", bodyClasses = ""} = classes

    useEffect(() => {
        if(open) {
            document.body.classList.add("block-scroll");
        } else {
            document.body.classList.remove("block-scroll");
        }
    }, [open]);

    return (
        <MobileSize>
            <div className={twMerge(`fixed bottom-0 left-0 w-screen z-[1000] duration-300 flex items-end ${open ? "opacity-100 h-screen" : "pointer-events-none h-0 overflow-hidden opacity-0"}`, parentClasses)}>
                <div className={twMerge("absolute right-0 bottom-0 bg-pol-blue-dark h-full w-full", overlayClasses)}
                onClick={onCloseModal}/>
                <div className={twMerge(`relative w-full bg-pol-light-purple-13 rounded-t-3xl z-[1000] duration-300 pt-8 ${open ? "min-h-[65vh] h-[65%] overflow-y-auto" : "h-0 overflow-hidden"}`, bodyClasses)}>
                    {children}
                </div>
            </div>
        </MobileSize>
    )
}
